import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  root: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    opacity: 0.5,
    backgroundColor: 'white',
    zIndex: 1,
  },
}));

const DisablingCover = () => {
  const classes = useStyles();

  return <div className={classes.root}></div>;
};

export default DisablingCover;
